import { queryOptions } from '@tanstack/react-query';
import { useApiClient } from 'bff/ApiClientProvider';

export const clientSection14RenewalKeys = {
  base: () => ['section-14-renewals'] as const,
  getClients: () => ['section-14-renewals'] as const
};

export const getClientsWithSection14RenewalsDue = () => {
  const { reportingApi } = useApiClient();

  return queryOptions({
    queryKey: clientSection14RenewalKeys.getClients(),
    queryFn: () => reportingApi.reportingGetSection14ClientRenewal(),
    select: (response) => response.data
  });
};
